import { render, staticRenderFns } from "./RegistroLector.vue?vue&type=template&id=814ab6f2&"
import script from "./RegistroLector.vue?vue&type=script&lang=js&"
export * from "./RegistroLector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports